<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-pallet"></i></span>{{ 'UserMaintenance.UserEdit.UserEdit' | translate }}</h1>
    <p-card>
        <form>
            <div class="p-fluid formgrid grid">
                <div class="field col-6">
                    <label>{{ 'UserMaintenance.UserEdit.Account' | translate }}</label>
                    <input pInputText type="text" [disabled]= "true && isExistUser" [(ngModel)]="account" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label>{{ 'UserMaintenance.UserEdit.UserType' | translate }}</label>
                    <p-dropdown [filter]="true" [options]="userTypeOptions" [disabled]="isExistUser" (onChange)="userTypeChange($event, true)" [(ngModel)]="userTypeSelected" [ngModelOptions]="{standalone: true}"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>{{ 'UserMaintenance.UserEdit.Email' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label>{{ 'UserMaintenance.UserEdit.UserName' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="userName" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label>{{ 'UserMaintenance.UserEdit.EmployCode' | translate }}</label>
                    <input pInputText type="text" [(ngModel)]="employCode" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="field col-6">
                    <label>{{ 'UserMaintenance.UserEdit.IsActivated' | translate }}</label>
                    <div>
                        <p-inputSwitch class="ml-2" [(ngModel)]="isActivated" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="mt-2 mb-1 pt-3 top-solid">
              {{ 'UserMaintenance.UserEdit.DataAuthor' | translate }}
                <button pButton pRipple class="p-button-info p-button-xs ml-2" (click)="addRoleScope($event)" label=" {{ 'UserMaintenance.UserEdit.Button' | translate }}"></button>
            </div>
            <div class="pb-3 bottom-solid">
                <div *ngFor="let roleScope of roleScopes; let i = index" class="role-block">
                    <div class="p-fluid grid">
                        <div class="field col-6">
                            <label>{{ 'UserMaintenance.UserEdit.Role' | translate }}</label>
                            <p-dropdown [filter]="true" [options]="roleOptions" [(ngModel)]="roleScope.roleCode" [ngModelOptions]="{standalone: true}" optionValue="value"></p-dropdown>
                        </div>
                    </div>
                    <div *ngIf="hasRole('Tenant')" class="tenant-role p-fluid grid">
                        <div class="field col-12 pl-5">
                            <p-table [value]="roleScope.tenants" class="datatable" styleClass="p-datatable-gridlines">
                                <ng-template pTemplate="caption">
                                    <button pButton pRipple class="p-button-info p-button-xs ml-2" label="增加資料點" (click)="addTenentScope($event, roleScope)"></button>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Facility</th>
                                        <th>TenantCode</th>
                                        <th>OrgId</th>
                                        <th>Dept</th>
                                        <th>Brand</th>
                                        <th>Customer</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-tenant let-rowIndex="rowIndex">
                                    <tr>
                                        <td>
                                          <p-dropdown appendTo="body" [filter]="true" [options]="facilityOptions" [(ngModel)]="tenant.facility" [ngModelOptions]="{standalone: true}"></p-dropdown>
                                        </td>
                                        <td>
                                            <p-dropdown appendTo="body" [filter]="true" [options]="tenantOptions" [(ngModel)]="tenant.tenantCode" [ngModelOptions]="{standalone: true}"></p-dropdown>
                                        </td>
                                        <td>
                                            <input pInputText type="text" [(ngModel)]="tenant.orgId" [ngModelOptions]="{standalone: true}" />
                                        </td>
                                        <td>
                                            <input pInputText type="text" [(ngModel)]="tenant.dept" [ngModelOptions]="{standalone: true}" />
                                        </td>
                                        <td>
                                            <input pInputText type="text" [(ngModel)]="tenant.brand" [ngModelOptions]="{standalone: true}" />
                                        </td>
                                        <td>
                                            <input pInputText type="text" [(ngModel)]="tenant.customer" [ngModelOptions]="{standalone: true}" />
                                        </td>
                                        <td>
                                            <i class="pi pi-trash" (click)="deleteTenantScope($event, roleScope, rowIndex)"></i>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div *ngIf="hasRole('Shipping')" class="shipping-role p-fluid grid">
                        <div class="field col-6 pl-5">
                            <label>選擇倉別</label>
                            <p-multiSelect [options]="facilityOptions" [(ngModel)]="roleScope.shippings" [ngModelOptions]="{standalone: true}"></p-multiSelect>
                        </div>
                    </div>
                    <div *ngIf="hasRole('Forwarder')" class="forwarder-role p-fluid grid">
                        <div class="field col-12 pl-5">
                            <p-table [value]="roleScope.forwarders" class="datatable" styleClass="p-datatable-gridlines">
                                <ng-template pTemplate="caption">
                                    <button pButton pRipple class="p-button-info p-button-xs ml-2" label="增加資料點" (click)="addForwarderScope($event, roleScope)"></button>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Forwarder</th>
                                        <th>Tenant</th>
                                        <th>Facility</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-forwarder let-rowIndex="rowIndex">
                                    <tr>
                                        <td>
                                            <p-dropdown appendTo="body" [filter]="true" [options]="forwarderOptions" [(ngModel)]="forwarder.forwarderCode" [ngModelOptions]="{standalone: true}"></p-dropdown>
                                        </td>
                                        <td>
                                            <p-dropdown appendTo="body" [filter]="true" [options]="tenantOptions" [(ngModel)]="forwarder.tenantCode" [ngModelOptions]="{standalone: true}"></p-dropdown>
                                        </td>
                                        <td>
                                            <p-dropdown appendTo="body" [filter]="true" [options]="facilityOptions" [(ngModel)]="forwarder.facility" [ngModelOptions]="{standalone: true}"></p-dropdown>
                                        </td>
                                        <td>
                                            <i class="pi pi-trash" (click)="deleteForwarderScope($event, roleScope, rowIndex)"></i>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <!-- <div class="field col-6 pl-5">
                            <label>選擇貨代</label>
                            <p-multiSelect [options]="forwarderOptions" [(ngModel)]="roleScope.forwarders" [ngModelOptions]="{standalone: true}" [virtualScroll]="true" [itemSize]="59.2"></p-multiSelect>
                        </div> -->
                    </div>
                    <div *ngIf="hasRole('Customer')" class="forwarder-role p-fluid grid">
                        <div class="field col-6 pl-5">
                            <label>輸入客戶代碼</label>
                            <laas-customer-dropdown [(ngModel)]="roleScope.customers" [isSingle]="true" [showClear]="true" [permissionCode]="permissionCode" [divClass]="'p-fluid'"></laas-customer-dropdown>
                            <!-- <input type="text" pInputText [(ngModel)]="roleScope.customers" [ngModelOptions]="{standalone: true}" /> -->
                        </div>
                    </div>
                    <i class="pi pi-times" (click)="removeRoleScope($event, i)"></i>
                </div>
            </div>
            <div class="grid mt-5">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveRolesScopes($event)"></button>
                    <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtn($event)" class="p-button-secondary ml-2"></button>
                </div>
            </div>
        </form>
    </p-card>
</div>
